import * as S from './styled'
import { useForm, SubmitHandler } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
/**
 * Components
*/
import LayoutWithList from '../../../LayoutModal/WithList';
import ActionButton from '../../../Button/ActionButton';
import Loading from "../../../../components/Loading";
/**
 * hooks
*/
import { apiUpdate } from '../../../../hooks/apiUpdate';
import { useEffect } from 'react';
import useLoading from '../../../../hooks/useLoading';
/**
 * Interfaces
*/
import { Inputs } from 'Interfaces/IMaterials';

interface ICreate {
    isOpenModalMaterial: boolean;
    selectedUrlId: number | null;
    setModalClose: () => void;
    updateList: () => void;
}

export default function Update({ isOpenModalMaterial, setModalClose, selectedUrlId, updateList }: ICreate) {

    const {
        register,
        handleSubmit: handleFormSubmit,
        setValue,
        formState: { errors },
    } = useForm<Inputs>();

    const { handleSubmit } = apiUpdate(`material/${selectedUrlId}`);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {

            const response = await axiosInstance.get(`material/${selectedUrlId}`);
            const addressData = response.data;
            for (const key in addressData) {
                setValue(key as keyof Inputs, addressData[key]);
            }

        } catch (error) {
            console.log("Error: ", error);
        } finally {
            stopLoading();
        }
    };

    useEffect(() => {
        if (isOpenModalMaterial && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModalMaterial, selectedUrlId]);

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {

            const formattedData = {
                ...data,
                material: data.material.toUpperCase(), // Aqui você força caixa alta
            };

            const response = await handleSubmit(formattedData);
            if (response === 200) {
                alert("Tipo de armação atualizado com sucesso!");
                updateList();
                setModalClose();
            }
        } catch (error: any) {
            alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
        }
    };

    if (isOpenModalMaterial) {
        return (
            <LayoutWithList
                title='Editar Tipo de Armação'
                subTitle='Atualize as informações do tipo em sua base de dados.'
                setModalClose={setModalClose}
            >
                <S.Container>
                    {
                        isLoading ? (
                            <Loading />
                        ) :
                            <S.SeparateDiv>
                                <S.FormInput>
                                    <S.Label>
                                        Tipo de Armação
                                        <span>*</span>
                                    </S.Label>
                                    <S.Input placeholder='Informe o tipo de armação' type='text' {...register("material", { required: true })} />
                                    {errors.material && <S.InforErro>Campo Obrigatório</S.InforErro>}
                                </S.FormInput>

                                <S.ContentButton>
                                    <ActionButton name='Atualizar' onClick={handleFormSubmit(onSubmit)} />
                                </S.ContentButton>
                            </S.SeparateDiv>
                    }
                </S.Container>
            </LayoutWithList>
        )
    } return null
}